(function() { window.GUID_039b1c33_8147_42ce_90dd_d214bbf9450e = { getGuid: function() { return "039b1c33-8147-42ce-90dd-d214bbf9450e"; } }; })();
//namespace CS.App.Views._Shared.WallSections {
//  export function updateRacingBarChartControls(
//    nextDatasetIndex: number,
//    $leftButton: JQuery,
//    $rightButton: JQuery,
//    $startButton: JQuery,
//    $continueButton: JQuery,
//    $resetButton: JQuery,
//    $stopButton: JQuery,
//    sortedDatasetsLength: number
//  ) {
//    const currentDatasetIsFirst = nextDatasetIndex == 1;
//    const currentDatasetIsLast = nextDatasetIndex >= sortedDatasetsLength;
//    if (currentDatasetIsFirst || currentDatasetIsLast) {
//      if (currentDatasetIsFirst) {
//        CS.Helper.disableButtons([$leftButton]);
//        CS.Helper.enableButtons([$rightButton]);
//        CS.Helper.showButtons([$startButton]);
//        CS.Helper.hideButtons([$continueButton, $resetButton, $stopButton]);
//      }
//      if (currentDatasetIsLast) {
//        CS.Helper.disableButtons([$rightButton]);
//        CS.Helper.enableButtons([$leftButton]);
//        CS.Helper.showButtons([$resetButton]);
//        CS.Helper.hideButtons([$startButton, $continueButton, $stopButton]);
//      }
//    } else {
//      CS.Helper.enableButtons([$leftButton, $rightButton]);
//      CS.Helper.hideButtons([$startButton, $stopButton]);
//      CS.Helper.showButtons([$continueButton, $resetButton]);
//    }
//  }
//  export function getBackgroundColorsFor(
//    highlightedOpponentIds: number[]
//  ): string[] {
//    const divergentColorsCount = Object.keys(
//      Helper.DataVisualizationHelper.DIVERGENT_PALETTE
//    ).length;
//    return highlightedOpponentIds.length <= 1
//      ? [Helper.DataVisualizationHelper.MAIN_COLOR]
//      : divergentColorsCount > highlightedOpponentIds.length
//      ? Array.from({ length: highlightedOpponentIds.length }).map(
//          (color, index) => {
//            return Helper.DataVisualizationHelper.DEFAULT_COLOR;
//          }
//        )
//      : Object.keys(Helper.DataVisualizationHelper.DIVERGENT_PALETTE)
//          .map((key) => {
//            return Helper.DataVisualizationHelper.DIVERGENT_PALETTE[
//              key
//            ] as string;
//          })
//          .slice(0, highlightedOpponentIds.length);
//  }
//  export function updateRacingBarChartDatasetsColors(
//    sortedDatasets: RacingBarChart.RacingBarChartDatasetParsed[],
//    highlightedColors: string[],
//    followedOpponentId: number
//  ) {
//    let highlightedColorIndex = 0;
//    sortedDatasets.forEach((dataset, index) => {
//      dataset.data.forEach((dataPoint, index) => {
//        const highlightedColor = highlightedColors[highlightedColorIndex];
//        //const isHighlighted = highlightedOpponentIds.includes(
//        //    dataPoint.EntityBaseId
//        //) || dataPoint.EntityBaseId == followedOpponentId;
//        const isHighlighted = dataPoint.EntityBaseId == followedOpponentId;
//        const BackgroundColor = isHighlighted
//          ? `${highlightedColor}80`
//          : `${Helper.DataVisualizationHelper.DEFAULT_COLOR}80`;
//        const BorderColor = isHighlighted
//          ? `${highlightedColor}`
//          : `${Helper.DataVisualizationHelper.DEFAULT_COLOR}`;
//        if (isHighlighted) {
//          highlightedColorIndex++;
//        }
//        dataPoint.BackgroundColor = BackgroundColor;
//        dataPoint.BorderColor = BorderColor;
//        dataPoint.IsHighlighted = isHighlighted;
//      });
//      dataset.backgroundColor = dataset.data.map((dataPoint) => {
//        return dataPoint.BackgroundColor;
//      });
//      dataset.borderColor = dataset.data.map((dataPoint) => {
//        return dataPoint.BorderColor;
//      });
//    });
//  }
//  export function getSortedDatasetsFrom(
//    datasets: RacingBarChart.Dataset[],
//    rankingStatSortDirection: string
//  ): RacingBarChart.RacingBarChartDatasetParsed[] {
//    return datasets.map((dataset) => {
//      const data = dataset.Stats.map((stat, index) => {
//        const {
//          Value,
//          DisplayName,
//          DisplayValue,
//          RankingValue,
//          OpponentImageUrl,
//          EntityBaseId,
//          IsTransitionStat,
//        } = stat;
//        return {
//          x: DisplayValue,
//          //y: DisplayName,
//          y: `${EntityBaseId}`,
//          Value,
//          DisplayName,
//          DisplayValue,
//          RankingValue,
//          OpponentImageUrl,
//          EntityBaseId,
//          BackgroundColor: "white",
//          BorderColor: "white",
//          IsTransitionStat,
//        };
//      }).sort((a, b) => {
//        if (rankingStatSortDirection == "ascending") {
//          return a.RankingValue - b.RankingValue;
//        }
//        return b.RankingValue - a.RankingValue;
//      });
//      return {
//        data: data,
//        backgroundColor: data.map((dataPoint) => {
//          return dataPoint.BackgroundColor;
//        }),
//        borderColor: data.map((dataPoint) => {
//          return dataPoint.BorderColor;
//        }),
//        borderWidth: 1,
//        borderRadius: 5,
//        IsTransitionDataset: dataset.IsTransitionDataset,
//        DatasetId: `${dataset.Date}-${Math.random()}`,
//      };
//    }) as RacingBarChart.RacingBarChartDatasetParsed[];
//  }
//  export function setRacingBarChartDateLabels(
//    datasetIndex: number,
//    datasets: RacingBarChart.Dataset[],
//    $currentDateLabel: JQuery,
//    data: {
//      params: RacingBarChart.Params;
//      data: {
//        datasets: Array<RacingBarChart.Dataset>;
//      };
//      elements: RacingBarChart.HtmlElements;
//    },
//    nextRealDatasetIndex: number,
//    $nextDateLabel: JQuery,
//    previousRealDatasetIndex: number,
//    $previousDateLabel: JQuery
//  ) {
//    const nextDatasetIndex =
//      datasetIndex < datasets.length - 1 ? datasetIndex + 1 : datasetIndex;
//    const previousDatasetIndex =
//      datasetIndex > 0 ? datasetIndex - 1 : datasetIndex;
//    const nextDatasetExists = nextDatasetIndex != datasetIndex;
//    const previousDatasetExists = previousDatasetIndex != datasetIndex;
//    const dataset = datasets[datasetIndex];
//    $currentDateLabel.text(`${dataset.Date.trim()}`);
//    if (
//      data.params.shouldDisplayWeekNumber &&
//      dataset.DateSubtitle != null &&
//      dataset.DateSubtitle.trim() != ""
//    ) {
//      $currentDateLabel.text(
//        `${dataset.DateSubtitle.trim()} – ${dataset.Date.trim()}`
//      );
//    }
//    if (nextDatasetExists) {
//      const nextDataset = datasets[nextRealDatasetIndex];
//      const nextDateLabel = nextDataset.Date;
//      $nextDateLabel.text(`${nextDateLabel}`);
//      CS.Helper.removeInlineStyleProps($nextDateLabel, [
//        "background-color",
//        "border",
//        "opacity",
//      ]);
//    } else {
//      $nextDateLabel.text(" ");
//      $nextDateLabel.css({
//        "background-color": "transparent",
//        border: "unset",
//        opacity: "0",
//      });
//    }
//    if (previousDatasetExists) {
//      const previousDataset = datasets[previousRealDatasetIndex];
//      const previousDateLabel = previousDataset.Date;
//      $previousDateLabel.text(`${previousDateLabel}`);
//      CS.Helper.removeInlineStyleProps($previousDateLabel, [
//        "background-color",
//        "border",
//        "opacity",
//      ]);
//    } else {
//      $previousDateLabel.text(" ");
//      $previousDateLabel.css({
//        "background-color": "transparent",
//        border: "unset",
//        opacity: "0",
//      });
//    }
//  }
//  export function getRacingBarChartFollowedOpponentInitialIndex(
//    followedOpponentId: number,
//    datasets: RacingBarChart.RacingBarChartDatasetParsed[]
//  ) {
//    const followedEntityBaseIdIndexes =
//      followedOpponentId == null
//        ? []
//        : datasets.map((d) =>
//            d.data.findIndex((s) => s.EntityBaseId == followedOpponentId)
//          ) ?? [];
//    const followedEntityBaseIdInitalIndex =
//      followedEntityBaseIdIndexes.length > 0
//        ? followedEntityBaseIdIndexes[0]
//        : -1;
//    return followedEntityBaseIdInitalIndex;
//  }
//  export function findRacingBarChartNextAndPreviousRealDatasetIndexes(
//    sortedDatasets: RacingBarChart.RacingBarChartDatasetParsed[],
//    datasetIndex: number,
//    sortedDatasetsInverted: RacingBarChart.RacingBarChartDatasetParsed[]
//  ) {
//    if (datasetIndex >= sortedDatasets.length) {
//      datasetIndex = sortedDatasets.length - 1;
//    }
//    if (datasetIndex < 0) {
//      datasetIndex = 0;
//    }
//    const currentDataset = sortedDatasets[datasetIndex];
//    let nextRealDatasetIndex = sortedDatasets.findIndex((dataset, index) => {
//      return index > datasetIndex && !dataset.IsTransitionDataset;
//    });
//    if (nextRealDatasetIndex == -1) {
//      nextRealDatasetIndex = sortedDatasets.length - 1;
//    }
//    const datasetIndexInverted = sortedDatasetsInverted.findIndex(
//      (dataset, index) => {
//        return dataset.DatasetId == currentDataset.DatasetId;
//      }
//    );
//    let previousRealDatasetIndexInverted = sortedDatasetsInverted.findIndex(
//      (dataset, index) => {
//        return index > datasetIndexInverted && !dataset.IsTransitionDataset;
//      }
//    );
//    let previousRealDatasetIndex = -1;
//    if (previousRealDatasetIndexInverted > -1) {
//      const previousRealDatasetInverted =
//        sortedDatasetsInverted[previousRealDatasetIndexInverted];
//      previousRealDatasetIndex = sortedDatasets.findIndex((dataset, index) => {
//        return dataset.DatasetId == previousRealDatasetInverted.DatasetId;
//      });
//    }
//    return {
//      nextRealDatasetIndex,
//      previousRealDatasetIndex,
//    };
//  }
//  export function setRacingBarChartProgressBarDatesLabels(
//    allDates: string[],
//    $datesSpanContainer: JQuery
//  ) {
//    const displayedDates = [];
//    if (allDates.length >= 5) {
//      displayedDates.push(allDates[0]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 1) / 4)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 2) / 4)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 3) / 4)]);
//      displayedDates.push(allDates[allDates.length - 1]);
//    } else if (allDates.length >= 4) {
//      displayedDates.push(allDates[Math.floor((allDates.length * 0) / 3)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 1) / 3)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 2) / 3)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 3) / 3)]);
//    } else if (allDates.length >= 3) {
//      displayedDates.push(allDates[Math.floor((allDates.length * 0) / 2)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 1) / 2)]);
//      displayedDates.push(allDates[Math.floor((allDates.length * 2) / 2)]);
//    } else {
//      displayedDates.push(allDates[0]);
//      displayedDates.push(allDates[allDates.length - 1]);
//    }
//    displayedDates.forEach((date) => {
//      $datesSpanContainer.append(`<span class="date">${date}</span>`);
//    });
//  }
//  export function bindRacingBarChartControlElements(
//    accordion: Controls.Accordion,
//    handleChartAnimationStart: () => void,
//    handleChartAnimationContinue: () => void,
//    handleChartAnimationStop: () => void,
//    handleChartReset: () => void,
//    handleChartScrollRight: () => void,
//    handleChartScrollLeft: () => void,
//    handleChartScrollTop: (incrementAmount: number) => void,
//    handleChartScrollBottom: (incrementAmount: number) => void
//  ) {
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelStartButton",
//      // `#${RacingBarChart.START_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelStartButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartAnimationStart()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelContinueButton",
//      // `#${RacingBarChart.CONTINUE_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelContinueButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartAnimationContinue()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelStopButton",
//      // `#${RacingBarChart.STOP_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelStopButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartAnimationStop()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelResetButton",
//      // `#${RacingBarChart.RESET_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelResetButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartReset()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelRightButton",
//      // `#${RacingBarChart.RIGHT_ARROW_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowRightButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollRight()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelNextDate",
//      `#RacingBarChartSectionViewModelNextDate-${accordion.ContentId}`,
//      () => handleChartScrollRight()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelLeftButton",
//      // `#${RacingBarChart.LEFT_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowLeftButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollLeft()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelPreviousDate",
//      `#RacingBarChartSectionViewModelPreviousDate-${accordion.ContentId}`,
//      () => handleChartScrollLeft()
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelTopButton",
//      // `#${RacingBarChart.TOP_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowTopButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollTop(1)
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelBottomButton",
//      // `#${RacingBarChart.BOTTOM_BUTTON_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowBottomButton-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollBottom(1)
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelTopButtonMore",
//      // `#${RacingBarChart.TOP_BUTTON_MORE_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowTopButtonMore-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollTop(10)
//    );
//    accordion.$Content.offon(
//      "click.RacingBarChartSectionViewModelBottomButtonMore",
//      // `#${RacingBarChart.BOTTOM_BUTTON_MORE_ID_PREFIX}-${accordion.ContentId}`.toLowerCase(),
//      `#button-RacingBarChartSectionViewModelArrowBottomButtonMore-${accordion.ContentId}`.toLowerCase(),
//      () => handleChartScrollBottom(10)
//    );
//  }
//  export function setAllDatesLabels(
//    sortedDatasets: RacingBarChart.RacingBarChartDatasetParsed[],
//    datasetIndex: number,
//    sortedDatasetsInverted: RacingBarChart.RacingBarChartDatasetParsed[],
//    datasets: RacingBarChart.Dataset[],
//    $currentDateLabel: JQuery,
//    data: {
//      params: RacingBarChart.Params;
//      data: {
//        datasets: Array<RacingBarChart.Dataset>;
//      };
//      elements: RacingBarChart.HtmlElements;
//    },
//    $nextDateLabel: JQuery,
//    $previousDateLabel: JQuery
//  ) {
//    const { nextRealDatasetIndex, previousRealDatasetIndex } =
//      findRacingBarChartNextAndPreviousRealDatasetIndexes(
//        sortedDatasets,
//        datasetIndex,
//        sortedDatasetsInverted
//      );
//    setRacingBarChartDateLabels(
//      datasetIndex,
//      datasets,
//      $currentDateLabel,
//      data,
//      nextRealDatasetIndex,
//      $nextDateLabel,
//      previousRealDatasetIndex,
//      $previousDateLabel
//    );
//  }
//  export function getRacingBarChartHtmlElements(
//    accordionContentId
//  ): RacingBarChart.HtmlElements {
//    const $dataInput = $(
//      `#RacingBarChartSectionViewModelData-${accordionContentId}`
//    );
//    const $progressBar = $(
//      `#RacingBarChartSectionViewModelProgressBar-${accordionContentId}`
//    );
//    const $datesContainer = $(
//      `#RacingBarChartSectionViewModelCurrentDate-${accordionContentId}`
//    );
//    const $previousDateLabel = $datesContainer.find(".previous-date");
//    //const $currentDateLabel = $datesContainer.find(".current-date");
//    const $currentDateLabel = $(
//      `#RacingBarChartSectionViewModelCurrentDateCURRENT-${accordionContentId}`
//    );
//    const $nextDateLabel = $datesContainer.find(".next-date");
//    const $startButton = $(
//      `#button-RacingBarChartSectionViewModelStartButton-${accordionContentId}`.toLowerCase()
//    );
//    const $continueButton = $(
//      `#button-RacingBarChartSectionViewModelContinueButton-${accordionContentId}`.toLowerCase()
//    );
//    const $stopButton = $(
//      `#button-RacingBarChartSectionViewModelStopButton-${accordionContentId}`.toLowerCase()
//    );
//    const $resetButton = $(
//      `#button-RacingBarChartSectionViewModelResetButton-${accordionContentId}`.toLowerCase()
//    );
//    const $leftButton = $(
//      `#button-RacingBarChartSectionViewModelArrowLeftButton-${accordionContentId}`.toLowerCase()
//    );
//    const $rightButton = $(
//      `#button-RacingBarChartSectionViewModelArrowRightButton-${accordionContentId}`.toLowerCase()
//    );
//    const $topButton = $(
//      `#button-RacingBarChartSectionViewModelArrowTopButton-${accordionContentId}`.toLowerCase()
//    );
//    const $bottomButton = $(
//      `#button-RacingBarChartSectionViewModelArrowBottomButton-${accordionContentId}`.toLowerCase()
//    );
//    const $topButtonMore = $(
//      `#button-RacingBarChartSectionViewModelArrowTopButtonMore-${accordionContentId}`.toLowerCase()
//    );
//    const $bottomButtonMore = $(
//      `#button-RacingBarChartSectionViewModelArrowBottomButtonMore-${accordionContentId}`.toLowerCase()
//    );
//    const $progressBarContainer = $(
//      `#RacingBarChartSectionViewModelProgressBarContainer-${accordionContentId}`
//    );
//    const $dateInputs = $(
//      `[id*="RacingBarChartSectionViewModelDate-${accordionContentId}"]`
//    );
//    return {
//      $dataInput,
//      $progressBar,
//      $datesContainer,
//      $previousDateLabel,
//      $currentDateLabel,
//      $nextDateLabel,
//      $startButton,
//      $continueButton,
//      $stopButton,
//      $resetButton,
//      $leftButton,
//      $rightButton,
//      $topButton,
//      $bottomButton,
//      $topButtonMore,
//      $bottomButtonMore,
//      $progressBarContainer,
//      $dateInputs,
//    };
//  }
//  export function getRacingBarChartDatasetsFrom(
//    htmlElements: RacingBarChart.HtmlElements
//  ): Array<RacingBarChart.Dataset> {
//    const datasets: Array<RacingBarChart.Dataset> = [];
//    htmlElements.$dateInputs.each((index, element) => {
//      const $element = $(element);
//      const inputVal = $element.val();
//      if (inputVal != null && inputVal.trim() != "") {
//        const parsedVal = JSON.parse(inputVal) as RacingBarChart.Dataset;
//        const {
//          Date,
//          Stats,
//          IsTransitionDataset,
//          DateSubtitle,
//          DecimalCount,
//          DecimalCount1,
//          WeekNo,
//        } = parsedVal;
//        if (Date && Stats) {
//          datasets.push({
//            Date,
//            Stats,
//            IsTransitionDataset,
//            DateSubtitle,
//            DecimalCount,
//            DecimalCount1,
//            WeekNo,
//          });
//        }
//      }
//    });
//    return datasets;
//  }
//  export function extractRacingBarChartParamsFrom(data: any) {
//    let highlightedOpponentIds: number[] = [];
//    let followedOpponentId: number | null = null;
//    let rankingStatSortDirection: RacingBarChart.SortDirection = "ascending";
//    let entityType: CS.Enumeration.EntityType | null = null;
//    if (
//      data.HighlightedEntityBaseIds != null &&
//      data.HighlightedEntityBaseIds.trim() != ""
//    ) {
//      highlightedOpponentIds = data.HighlightedEntityBaseIds.split(",").map(
//        (x) => parseInt(x)
//      );
//    }
//    if (
//      data.FollowedEntityBaseId != null &&
//      data.FollowedEntityBaseId.trim() != ""
//    ) {
//      followedOpponentId = parseInt(data.FollowedEntityBaseId);
//    }
//    if (
//      data.RankingStatSortingOrder != null &&
//      data.RankingStatSortingOrder.trim() != ""
//    ) {
//      rankingStatSortDirection =
//        data.RankingStatSortingOrder.toLowerCase() as RacingBarChart.SortDirection;
//    }
//    if (data.EntityType != null) {
//      entityType = data.EntityType as CS.Enumeration.EntityType;
//    } 
//    return { 
//      highlightedOpponentIds, 
//      followedOpponentId,
//      rankingStatSortDirection,
//      entityType,
//    };
//  }
//  export function formatRacingBarChartParams(
//    highlightedOpponentIds: number[],
//    followedOpponentId: number,
//    parsedData: RacingBarChart.RacingBarChartDataRaw,
//    rankingStatSortDirection: string,
//    entityType: Enumeration.EntityType,
//    datasets: RacingBarChart.Dataset[],
//    htmlElements: RacingBarChart.HtmlElements
//  ) {
//    return {
//      highlightedOpponentIds,
//      followedOpponentId: new CS.Helper.StatefulValue(followedOpponentId),
//      statGroupId: parsedData.StatGroupId,
//      statFieldId: parsedData.StatFieldId,
//      displayStatFieldId: parsedData.DisplayStatFieldId,
//      rankingStatFieldId: parsedData.RankingStatFieldId,
//      rankingStatSortDirection,
//      entityType,
//      shouldFollowOpponent: new CS.Helper.StatefulValue(
//        followedOpponentId != null
//      ),
//      interval: new CS.Helper.StatefulValue(null),
//      nextDatasetIndex: new CS.Helper.StatefulNumber(1),
//      previousDatasetIndex: new CS.Helper.StatefulNumber(-1),
//      updatesCount: new CS.Helper.StatefulNumber(0),
//      totalUpdatesCount: datasets.length - 1,
//      shouldStartAnimationAutomatically: !htmlElements.$startButton.length,
//      forceStopOnNextRealDataset: new CS.Helper.StatefulValue(false),
//      decimalsCount: datasets[0].DecimalCount1,
//      decimalsCount1: datasets[0].DecimalCount1,
//      shouldDisplayWeekNumber: parsedData.ShouldDisplayWeekNumber,
//    };
//  }
//}

//# sourceMappingURL=section.helpers.js.map
